import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { probabilitiesActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import ChipInput from 'material-ui-chip-input'
import { readOnly } from '../../utils/permissions'
import Chip from '@material-ui/core/Chip'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = probability => {
    const { onClose, addProbability, editProbability, changeMessage } = this.props
    if (probability._id) {
      editProbability(probability).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addProbability(probability).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, probability) => {
    e.preventDefault()
    const { setProbabilityFormTouched } = this.props

    if (this.props.probabilityFormErrors.valid) {
      this.handleSave(probability)
    } else {
      setProbabilityFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      probability,
      handleChangeProbability,
      loadingProbability,
      probabilityFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('probabilidades', token)

    return (
      <div>
        <Dialog
          modalId={probability._id ? 'probabilidades-editar' : 'probabilidades-nova'}
          modalParams={{ registro: probability._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingProbability ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(probability._id ? 'probabilidades-editar' : 'probabilidades-nova') + '-title'}>
                {isReadOnly ? (
                  'Probabilidade'
                ) : (
                  <Fragment>
                    {probability._id ? 'Editar probabilidade' : 'Cadastrar probabilidade'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'probability-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, probability)
                  }}
                >
                  <FormControl
                    error={
                      !((probabilityFormErrors.fields || {})['nome'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Probabilidade</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeProbability({ ...probability, nome: e.target.value })
                      }}
                      value={probability.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((probabilityFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((probabilityFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'probability-form'}
                    color="primary"
                    variant="raised"
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    probability: state.probabilities.probability,
    loadingProbability: state.probabilities.loadingProbability,
    probabilityFormErrors: state.probabilities.probabilityFormErrors,
    formTouched: state.probabilities.probabilityFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(probabilitiesActions.openModal())
    },
    closeModal: () => {
      dispatch(probabilitiesActions.closeModal())
    },
    handleChangeProbability: probability => {
      dispatch(probabilitiesActions.handleChangeProbability(probability))
    },
    addProbability: probability => {
      return dispatch(probabilitiesActions.addProbability(probability))
    },
    editProbability: probability => {
      return dispatch(probabilitiesActions.editProbability(probability))
    },
    setProbabilityFormTouched: probability => {
      dispatch(probabilitiesActions.setProbabilityFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/Probabilities/EditModal.js